import React, { useCallback, useEffect, useState } from "react";
import { ToastType } from "../../ToastManager/constants";
import { sendNotification } from "../../ToastManager/ToastManager";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import {
  mapDispatchToProps,
  mapStateToProps,
  commentsReducer,
} from "./CommentTable.store";
import CustomModal from "../../ui-library/CustomModal/CustomModal";
import CommentsTable from "../../library/CommentTable/CommentTable";
import styled from "styled-components";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";

const StyledScreenshotImg = styled.img`
  width: 100%;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 60px;
  @media (max-width: 576px) {
    padding-top: 2rem;
    margin-top: auto;
    .btn {
      width: 100%;
    }
  }
`;

export const SmartCommentTable = (props) => {
  const {
    comments,
    screenshot,
    totalItems,
    searchedParams,
    canViewScreenshot,
    clearScreenshot,
    fetchComments,
    fetchCommentScreenshot,
    resetState,
    loading,
  } = props;

  const [selectedComment, setSelectedComment] = useState(null);

  useEffect(() => {
    return () => resetState();
  }, [resetState]);

  const getData = useCallback(
    (params) => {
      fetchComments(params).catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
    },
    [fetchComments]
  );

  const openCommentImage = (element) => {
    setSelectedComment(element);
  };

  const closeCommentImage = () => {
    setSelectedComment(null);
    clearScreenshot();
  };

  useEffect(() => {
    if (selectedComment != null) {
      fetchCommentScreenshot(selectedComment.key);
    }
  }, [fetchCommentScreenshot, selectedComment]);

  useEffect(() => {
    if (totalItems === null) {
      getData(searchedParams);
    }
  }, [getData, searchedParams, totalItems]);

  return (
    <>
      <CustomModal
        title="Screenshot"
        onClose={closeCommentImage}
        show={!!selectedComment}
        titleSeparatorBg={props.theme?.greenGradient}
        size="xl"
      >
        {screenshot ? (
          <StyledScreenshotImg
            src={`data:image/png;base64,${screenshot}`}
            alt="Screenshot"
          />
        ) : (
          <LoadingSpinner />
        )}
        <ActionButtonsContainer>
          <PrimaryButton onClick={closeCommentImage}>Close</PrimaryButton>
        </ActionButtonsContainer>
      </CustomModal>

      <CommentsTable
        {...{ getData }}
        {...{ searchedParams }}
        totalitems={totalItems}
        loading={loading}
        {...{ comments }}
        {...{ canViewScreenshot }}
        {...{ openCommentImage }}
      />
    </>
  );
};

const mapToStateToProps = (state) => {
  return {
    ...mapStateToProps(state),
  };
};

export default dynamic(
  "commentsReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state, rootState) => ({
      loginReducer: state.loginReducer,
    }),
  }),
  attachReducer(commentsReducer)
)(connect(mapToStateToProps, mapDispatchToProps)(SmartCommentTable));
